import {connect} from "react-redux";
import IncreaseCreditLimit from "./Increaselimit";
import {bindActionCreators} from "redux";
import {increaseCreditLimit} from "../../../../services/redux/MaterialRequistionForm/action";
import {userById} from "../../../../services/redux/auth/login/action";

const mapStateToProps = (state) => ({
    addCreditLimit: state.MaterialRequistionForm.addCreditLimit,
    userProfile: state.loginReducer.userProfile,
    userDetailsById: state.loginReducer.userDetailsById
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            increaseCreditLimit,
            userById
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(IncreaseCreditLimit);
